/**
 * Pause / lecture vidéo au survol quand le texte de routine est affiché.
 */
(function () {
  function bind(card) {
    var v = card.querySelector('video');
    if (!v) return;
    card.addEventListener('mouseenter', function () {
      v.pause();
    });
    card.addEventListener('mouseleave', function () {
      v.play().catch(function () {});
    });
  }

  document.querySelectorAll('.eveline-routines-hub__card--has-reveal').forEach(bind);

  document.addEventListener('shopify:section:load', function (ev) {
    ev.target.querySelectorAll('.eveline-routines-hub__card--has-reveal').forEach(bind);
  });
})();
